<template>
  <div class="chart-container">
    <Pie
      ref="pieRef"
      :data="pieData"
      :options="pieOptions"
      :redraw="true"
      style="flex:1; max-height:35vh;"

    />
  </div>
</template>

<script setup>
import { ref, watch, onMounted } from 'vue'
import axios from '@/services/axios'
import { Pie } from 'vue-chartjs'
import { Chart, ArcElement, Tooltip, Legend } from 'chart.js'

Chart.register(ArcElement, Tooltip, Legend)

const props = defineProps({
  dataInicio: { type: String, required: true },
  dataFim:    { type: String, required: true }
})

const pieData = ref({
  labels: [],
  datasets: [{ data: [], backgroundColor: [] }]
})

const pieOptions = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    title: {
      display: true,
      text: 'Classificação Anual',
      align: 'start'
    },
    legend: {
      display: true,
      position: 'right',
      align: 'center'
    },
    tooltip: {
      callbacks: {
        title() {
          const ano = props.dataInicio.split('-')[0]
          return `${ano}`
        },
        label(ctx) {
          return `${ctx.label}: ${ctx.parsed.toLocaleString('pt-BR')}`
        },
        footer(ctxs) {
          const chart = ctxs[0].chart
          const dados = chart.data.datasets[0].data
          const total = dados.reduce((soma, v) => soma + v, 0)
          return `Total anual: ${total.toLocaleString('pt-BR')}`
        }
      },
      footerFont: { weight: 'bold' }
    }
  }
}

async function fetchClassificacao() {
  try {
    const { data: resp } = await axios.get(
      '/gestao/graficos/individuais/classificacao-anual',
      { params: { dataInicio: props.dataInicio, dataFim: props.dataFim } }
    )

    const classificationMap = {}
    for (const [classif, arr] of Object.entries(resp.series)) {
      classificationMap[classif] = arr.reduce((sum, v) => sum + v, 0)
    }

    const palette = [
      '#4A90E2', '#1ABC9C', '#F5A623',
      '#E57373', '#9B59B6', '#34495E'
    ]

    pieData.value = {
      labels: Object.keys(classificationMap),
      datasets: [{
        data: Object.values(classificationMap),
        backgroundColor: palette.slice(0, Object.keys(classificationMap).length)
      }]
    }
  } catch (e) {
    console.error('Erro ao carregar classificação anual de prospecção:', e)
  }
}

onMounted(fetchClassificacao)
watch(
  () => [props.dataInicio, props.dataFim],
  fetchClassificacao
)
</script>

<style scoped>
.chart-container {
  width: 100%;
  /* altura em porcentagem do pai ou fixa, ajuste conforme necessidade */
  height: 300px;
}
@media (min-width: 768px) {
  .chart-container {
    height: 400px;
  }
}
</style>
